import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'
import { PageHeaderActions } from '@/components/layout/PageHeaderActions'
import { CreateCompanyButton } from './header-actions-components/CreateCompanyButton'
import { CompaniesTable } from './table-components/CompaniesTable'
import { CreateCompanyDialog } from './components/CreateCompanyDialog'

// Customer list of the super admin area (BON-1998). Creating a company is deliberately bare —
// assigning modules and templates comes later (BON-2034).
export default function SuperAdminCompaniesPage() {
  const { t } = useTranslation('super-admin-companies')
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false)

  return (
    <PageLayout>
      <PageHeader title={t('header.title')} description={t('header.description')}>
        <PageHeaderActions>
          <CreateCompanyButton onClick={() => setIsCreateDialogOpen(true)} />
        </PageHeaderActions>
      </PageHeader>

      <CompaniesTable />

      <CreateCompanyDialog isOpen={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen} />
    </PageLayout>
  )
}
